/// <reference types="@angular/localize" />


import { registerLicense } from '@syncfusion/ej2-base';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { importProvidersFrom } from '@angular/core';
import { AuthModule } from '@auth0/auth0-angular';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './app/interceptor/auth.interceptor';
import { provideRouter } from '@angular/router';
import { routes as appRoutes } from './app/app.routes';
import { environment } from './environments/environment';
import { DatePipe } from '@angular/common';
// Registering Syncfusion license key

console.log(
  '%c🚀 [Promotions App] Running from monorepo on Cloud Run 🚀',
  'background: #004f71; color: #ffffff; font-weight: bold; font-size: 14px; padding: 6px 12px; border-radius: 4px;'
);
console.info('[Platform]: Monorepo / Cloud Run | Target:', environment.baseUrl);

registerLicense('Ngo9BigBOggjHTQxAR8/V1JEaF5cXmRCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdlWX5ecnRTRWRcU0F3WkZWYEE=');
bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom([
      BrowserModule,
      AuthModule.forRoot({
        domain: environment.auth0Domain,
        clientId: environment.clientId,
        authorizationParams: {
          redirect_uri: window.location.origin,
          audience: environment.audience,
          scope: 'openid profile email offline_access'
        },
        useRefreshTokens: true,
        useRefreshTokensFallback: false,
        cacheLocation: 'memory',
        useFormData: true,
      })
    ]
    ),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptors([ authInterceptor ])),
    DatePipe
  ]
})
  .catch(err => console.error(err));
